require('./_reply');
var info = $('.roominfo').data('info');
console.log(info);
console.log('info');

window.startwatch = function () {
    var videoContent = '';
    videoContent += '<video id="viewcontent" class="video-js vjs-default-skin" controls style="min-width: 1400px; min-height: 787px;"   poster=';
    videoContent += '"' + info.cover_url + '" >';
    videoContent += '</video>';
    $('#content').html(videoContent)
    if (info.versions[0]) {
        startPlay(info.versions[0].url, 'viewcontent', false);
    }

    // var urls = [];

    // var urlmp4 = '';
    // var urlflv = '';
    // var urlm3u8 = '';
    // var urlother = '';

    // $.each(info.versions, function (i, val) {
    //     var path = val.url;
    //     var ext = getext(path);
    //     if (ext == 'mp4') {
    //         urlmp4 = path;
    //     } else if (ext == 'flv') {
    //         urlflv = path;
    //     } else {
    //         urlother = path;
    //     }

    //     if (ext == 'm3u8') {
    //         urlm3u8 = path;
    //     }
    // });

    // if (urlmp4.length > 0) {
    //     urls.push(urlmp4);
    // } else if (urlflv.length > 0) {
    //     urls.push(urlflv);
    // } else if (urlm3u8.length > 0) {
    //     urls.push(urlm3u8);
    // } else if (urlother.length > 0) {
    //     urls.push(urlother);
    // }

    // if (urls.length > 0) {
    //     urls = [urls.join(';')];
    //     if (initPlayer) {
    //         playerUrls = urls;
    //         setTimeout(replayurl, 800);
    //     } else {
    //         startPlay(urls, 1110, 624, playerSet, false);
    //     }
    // }
};

window.getSuggest = function () {
    showWait();
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/content/' + info.author_id + '/show?page=1&size=6',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                var str = '';
                for (var n = 0; n < result.data.length; n++) {
                    if (n == 6) {
                        break;
                    }
                    var info = result.data[n];
                    var targetHtml = '<a target="_blank" href="' + ROOT + '/content/' + info.id + '">';

                    var html =
                        '<div class="liveinfo">' +
                        targetHtml +
                        '<div class="liveinfo-img">' +
                        '<img src="' + info.cover_url + '?w=370&h=162&s=3">' +
                        '<div class="liveinfo-type"></div>' +
                        '<div class="liveinfo-hover"></div>' +
                        '</div>' +
                        '<div class="liveinfo-title">' +
                        '<div class="liveinfo-title-name">' + info.title + '</div>' +
                        '</div>' +
                        '<div class="liveinfo-user">' +
                        '<div class="liveinfo-user-name">' + (info.author_nickname || '') + '</div>' +
                        '<div class="liveinfo-user-visitcount">' + info.like_count + '</div>' +
                        '</div>' +
                        '</a>' +
                        '</div>';

                    str += html;
                }

                var html = '<div class="showtabs">' +
                    '            <div class="showtab">推荐视频</div>' +
                    '        </div>' +
                    '        <div class="curentlives">' +
                    '            <div class="livelist">' +
                    str +
                    '            </div>' +
                    '        </div>';

                $('.list').append(html);
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
        },
        complete: function (XMLHttpRequest, textStatus) {
        }
    });
};

startwatch();

getSuggest();